import Cookie from 'js-cookie';
export default {
  data() {
  },
  methods: {
    //判断是否登录
    isLogin() {
      if (!localStorage.loginData) {
        this.$router.push({
          path: "/",
        });
      }
      // console.log(document.cookie = "name=value;domain=.ddbes.com") // 就能得到当前 cookie 的值
    },
    date_change(value) {
      if (!value) return '';
      const date = new Date(Number(value));
      let y = date.getFullYear();
      let m = String(date.getMonth() + 1).length === 1 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      let d = String(date.getDate()).padStart(2, '0');
      return `${y}/${m}/${d}`;
    },
    formateDate(value) {
      var day_val =
        value.getFullYear() +
        "-" +
        (value.getMonth() + 1) +
        "-" +
        value.getDate();
      return `${day_val}`;
    },
    formateDate(value) {
      var day_val =
        value.getFullYear().toString() +
        "-" +
        (value.getMonth() + 1 < 10
          ? "0" + (value.getMonth() + 1).toString()
          : (value.getMonth() + 1).toString()) +
        "-" +
        (value.getDate() < 10
          ? "0" + value.getDate().toString()
          : value.getDate().toString())
      return `${day_val}`;
    },
    //设置默认日期
    defaultDate() {
      //获取新的时间(2019.4.12）
      let date = new Date();
      //获取当前时间的年份转为字符串
      let year = date.getFullYear().toString(); //'2019'
      //获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString(); //'04'
      //获取天，判断是否小于10，如果是在字符串前面拼接'0'
      let da =
        date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString(); //'12'
      //字符串拼接，开始时间，结束时间
      let end = year + "-" + month + "-" + da; //当天'2019-04-12'
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.time = [start, end]; //将值设置给插件绑定的数据
    },
    headerClass() {
      return "background-color:#FAFCFF;height:32px;padding:5px";
    },
    class_name({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "popularLine";
      } else {
        return "colorLine";
      }
    }
  }
};
